import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { MillManagerPage } from '../pages/mill-manager/mill-manager';
import { ContactsPage } from '../pages/contacts/contacts';
import { DeliveryPage } from '../pages/delivery/delivery';
import { PickupPage } from '../pages/pickup/pickup';
import { ProductionPage } from '../pages/production/production';
import { SmpPage } from '../pages/smp/smp';
import { HelpPage } from '../pages/help/help';

import { LoginPage } from '../pages/login/login';
import { AuthProvider } from '../providers/auth/auth';

import { AngularFireAuth } from 'angularfire2/auth';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  //rootPage: any = MillManagerPage;
  rootPage: any;

  pages: Array<{title: string, component: any}>;

  constructor(public platform: Platform, afAuth: AngularFireAuth, public authData: AuthProvider,
    public statusBar: StatusBar, public splashScreen: SplashScreen) {
    this.initializeApp();

    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'Home', component: MillManagerPage},
      { title: 'Contacts', component: ContactsPage},
      { title: 'Delivery', component: DeliveryPage},
      { title: 'Pickup', component: PickupPage},
      { title: 'Production', component: ProductionPage},
      { title: 'Service & M', component: SmpPage},
      { title: 'Help', component: HelpPage}
    ];

    afAuth.auth.onAuthStateChanged( firebaseUser => {
      if (firebaseUser) {
        console.log(firebaseUser.email + ' firebase user logged in...');
        this.nav.setRoot(MillManagerPage);
        //this.rootPage = MillManagerPage;
      } else {
        console.log(firebaseUser + ' firebase user logged out...');
        this.nav.setRoot(LoginPage);
        //this.rootPage = LoginPage;
      }
    });

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  logoutUser() {
    this.authData.logoutUser();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts